import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../classes/user';

@Pipe({
  name: 'roleFilter',
  pure: false
})
export class RoleFilterPipe implements PipeTransform {

  transform(userList: Array<User>, filterValue: string): any {
    if (!userList || !filterValue) {
      return userList;
    }
    return userList.filter(user => user.role.value.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
